import InputCheck from './Check';
import InputDateTime from './DateTime';
import InputImage from './Image';
import InputNumber from './Number';
import InputPassword from './Password';
import InputRating from './Rating';
import InputSelect from './Select';
import { type SelectDataObject } from './Select';
import InputSlider from './Slider';
import InputText from './Text';

export const sInputfields: SelectDataObject<{ component?: any }>[] = [
    { i: ['check', 'switch'], component: InputCheck },
    { i: ['year', 'month', 'date', 'datetime', 'datetimeSec', 'time', 'range-year', 'range-month', 'range-date', 'range-datetime', 'range-datetimeSec', 'range-time'], component: InputDateTime },
    { i: ['avatar', 'image', 'image360i', 'image360a'], component: InputImage },
    { i: ['decimal', 'currency', 'percent'], component: InputNumber },
    { i: 'password', component: InputPassword },
    { i: 'rating', component: InputRating },
    { i: ['singleselect', 'multiselect', 'radio'], component: InputSelect },
    { i: ['slider', 'range'], component: InputSlider },
    { i: ['text', 'multiline', 'tel', 'email', 'fax'], component: InputText },
];
